import DataTableExtensions from 'react-data-table-component-extensions';
import DataTable from 'react-data-table-component';
import React, { Component } from 'react';
import Select from 'react-select';
import ValidForm from 'react-valid-form-component';
import { T } from 'react-translator-component';
import PropTypes from 'prop-types';
import { BreadCrumb, Card, Modal, ErrorMessage, Validation } from '../../components';
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Partner } from '../../config/AppConfig';

export class UserPublisherAccount extends Component {
  constructor(props) {
    super(props);

    const pageConfig = 'userPublisherAccount';

    const { UserId } = props;

    this.state = {
      dataTable: {
        columns: DataTableColumns.admin[pageConfig],
        rows: [],
      },
      modal: false,
      url: Partner.service.admin[pageConfig],
      validation: {
        error: false,
        message: '',
        checkValid: false,
      },
      data: {},
      filter: {
        companySelected: { label: 'All', value: '-1' },
        companyList: [{ label: 'All', value: '-1' }],
        userId: UserId,
      },
      list: {
        user: [],
        company: [],
        publisher: new Map(),
        status: [{ value: true, label: T('Active') }, { value: false, label: T('Passive') }],
      },
    };

    this.onEdit = this.onEdit.bind(this);
  }

  componentDidMount() {
    this.getTable();
  }

  componentDidUpdate() {
    const { filter } = this.state;
    const { UserId } = this.props;

    if (filter.userId !== UserId) {
      filter.userId = UserId;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        filter,
      });
    }
  }

  onChangeSelect(val, key) {
    const { data } = this.state;
    data[key] = val;
    if (key === 'companySelected') {
      data.companyId = val.value;
    }
    this.setState({
      data,
    });
  }

  onEdit(id) {
    const { url, list } = this.state;
    let { data } = this.state;
    Service.Admin.Detail({ id }, url).then(response => {
      if (response && response.error === false) {
        data = response.data;

        const [company] = list.company.filter(f => f.value === data.companyId);
        data.companySelected = company;
        const [user] = list.user.filter(f => f.value === data.userId);
        data.userSelected = user;

        const [parentPublisherSelected] = list.publisher.get(data.companyId).filter(f => f.value === data.parentPublisher);
        data.parentPublisherSelected = parentPublisherSelected;

        const [statusSelected] = list.status.filter(f => f.value === data.status);
        data.statusSelected = statusSelected;

        this.setState({
          data,
          validation: {
            error: false,
            message: '',
            checkValid: false,
          },
          modal: true,
        });
      }
    });
  }

  onSave(data, valid) {
    const { url } = this.state;
    const { data: thisData } = this.state;
    this.checkValid();
    if (valid) {
      if (thisData.userSelected && thisData.companySelected && thisData.statusSelected) {
        const postData = data;
        postData.userId = thisData.userSelected.value;
        postData.companyId = thisData.companySelected.value;
        postData.parentPublisher = thisData.parentPublisherSelected ? thisData.parentPublisherSelected.value : 0;
        postData.status = thisData.statusSelected.value;

        Service.Admin.Save(postData, url).then(response => {
          if (response) {
            if (response.error === false) {
              this.setState({
                modal: false,
                data: {},
              });
              this.getTable();
            } else {
              this.setState({
                validation: {
                  error: response.error,
                  message: response.message,
                  checkValid: false,
                },
              });
            }
          }
        });
      }
    }
  }

  onNew() {
    this.setState({
      modal: true,
      data: {},
      validation: {
        error: false,
        message: '',
        checkValid: false,
      },
    });
  }

  getTable() {
    const { dataTable, url, filter, list } = this.state;
    const urlClone = { ...url };
    urlClone.list = `${url.list}/${filter.userId}`;
    Service.Admin.List(urlClone).then(response => {
      if (response && response.error === false) {
        dataTable.rows = response.data.data;
        list.user = response.data.common.user;
        list.company = response.data.common.company;

        filter.companyList = filter.companyList.concat(response.data.common.company);

        response.data.common.publisher.forEach(item => {
          list.publisher.set(item.companyId, item.list);
        });

        this.setState({
          dataTable,
          filter,
          list,
        });

        this.tableRows = response.data.data;
      }
    });
  }

  checkValid() {
    this.setState(prevState => ({
      validation: {
        ...prevState.validation,
        checkValid: true,
      },
    }));
  }

  render() {
    const { dataTable, data, validation, modal, filter, list } = this.state;
    const { Detail } = this.props;
    return (
      <>
        {!Detail && <BreadCrumb Title="User Publisher Account" Description="Lorem ipsum dolor sit amet" />}
        <Card Title="User Publisher Account" Description="Lorem ipsum dolor sit amet">
          <Modal Title={T('Edit User Publisher Account')} Show={modal} onClose={() => this.setState({ modal: false, data: {} })}>
            <div className="row mt-1 mb-1">
              <p className="text-muted mb-2 ml-1 col-md-12 font-12">{T('User Publisher Account')}</p>
              <div className="col-md-12">
                <ValidForm className="form-horizontal m-t-10" nosubmit novalid onSubmit={(form, formData, valid) => this.onSave(formData, valid)} data={data}>
                  <div className="form-group">
                    <div className="row">
                      <ErrorMessage Validation={validation} />
                    </div>
                  </div>
                  <div className="form-group">
                    <input type="hidden" className="form-control" id="id" name="id" />
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="company" className="col-sm-4 col-form-label">{T('Company')}</label>
                    <div className="col-sm-8">
                      <Select
                        value={data.companySelected}
                        options={list.company}
                        onChange={option => this.onChangeSelect(option, 'companySelected')}
                        isMulti={false}
                      />
                      <Validation Value={data.companySelected} Check={validation.checkValid} />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="user" className="col-sm-4 col-form-label">{T('User')}</label>
                    <div className="col-sm-8">
                      <Select
                        value={data.userSelected}
                        options={list.user}
                        onChange={option => this.onChangeSelect(option, 'userSelected')}
                        isMulti={false}
                      />
                      <Validation Value={data.userSelected} Check={validation.checkValid} />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="publisher" className="col-sm-4 col-form-label">{T('Publisher')}</label>
                    <div className="col-sm-8">
                      <input type="number" className="form-control" id="publisherId" name="publisherId" placeholder={T('Publisher')} required />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="parentPublisher" className="col-sm-4 col-form-label">{T('Parent Publisher')}</label>
                    <div className="col-sm-8">
                      <Select
                        value={data.parentPublisherSelected}
                        options={list.publisher.get(data.companyId)}
                        onChange={option => this.onChangeSelect(option, 'parentPublisherSelected')}
                        isMulti={false}
                      />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="metaAccount" className="col-sm-4 col-form-label">{T('Meta Account')}</label>
                    <div className="col-sm-8">
                      <input type="number" className="form-control" id="metaAccount" name="metaAccount" placeholder={T('Meta Account')} />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="defaultGroup" className="col-sm-4 col-form-label">{T('Default Group')}</label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control" id="defaultGroup" name="defaultGroup" placeholder={T('Default Group')} />
                    </div>
                  </div>
                  <div className="form-group row ml-1 mr-1">
                    <label htmlFor="login" className="col-sm-4 col-form-label">{T('Status')}</label>
                    <div className="col-sm-8">
                      <Select
                        value={data.statusSelected}
                        options={list.status}
                        onChange={option => this.onChangeSelect(option, 'statusSelected')}
                        isMulti={false}
                      />
                      <Validation Value={data.statusSelected} Check={validation.checkValid} />
                    </div>
                  </div>
                  <div className="form-group row m-t-20 mr-1">
                    <div className="col-sm-12 text-right">
                      <button type="submit" className="btn btn-success w-md waves-effect waves-light">{T('Save')}</button>
                    </div>
                  </div>
                </ValidForm>
              </div>
            </div>
          </Modal>
          <div className="row">
            <div className="col-md-12 mb-5 pp-select-company">
              <div className="form-group mb-0">
                <label>{T('Company')}</label>
                <Select
                  value={filter.companySelected}
                  options={filter.companyList}
                  onChange={option => {
                    if (option.value === '-1') {
                      dataTable.rows = this.tableRows;
                    } else {
                      dataTable.rows = this.tableRows.filter(f => f.companyId === option.value);
                    }

                    filter.companySelected = option;

                    this.setState({ filter, dataTable });
                  }}
                  isMulti={false}
                />
              </div>
            </div>
            <div className="col-md-12">
              <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={() => this.onNew()}>
                <i className="fas fa-plus  mr-2" />
                {T('Add New')}
              </button>
              <DataTableExtensions columns={dataTable.columns(this.onEdit)} data={dataTable.rows} export={false} print={false}>
                <DataTable
                  className="tbl-admin-symbol"
                  noHeader
                  defaultSortField="id"
                  defaultSortAsc={false}
                  pagination
                  highlightOnHover
                />
              </DataTableExtensions>
            </div>
          </div>
        </Card>
      </>
    );
  }
}

UserPublisherAccount.propTypes = {
  Detail: PropTypes.number,
  UserId: PropTypes.number,
};

UserPublisherAccount.defaultProps = {
  Detail: undefined,
  UserId: -1,
};
